import { useQuery } from '@tanstack/react-query';
import { ODataQuery } from './ODataApi';
import { getPluralEntity } from '../utils/entities';

export const useValidations = (
  accountId,
  entityType,
  service_version,
  endpoint_path,
  options,
) => {
  const params = options || {};

  let pluralEntity = getPluralEntity(entityType)('entityHook');
  return useQuery({
    queryKey: [accountId, pluralEntity, service_version, endpoint_path, params],
    queryFn: async () => {
      const pluralEntity = getPluralEntity(entityType)('entityHook');
      let query = new ODataQuery(
        `accounts/${accountId}/services/${pluralEntity}/odata/${service_version}/${endpoint_path}`,
      );

      if (process.env.NX_PUBLIC_API_BASE_URL?.includes('localhost')) {
        query.baseUrl = 'http://localhost/sophia/';
      }

      return await query.run();
    },
    ...params,
    staleTime: 0,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });
};
